"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const core_1 = require("@material-ui/core");
const styles_tsx_1 = tslib_1.__importDefault(require("src/app/maintenance/assets/styles.tsx"));
const Icons_1 = require("src/components/Icons");
function CheckBoxDropDown(props) {
    const classes = styles_tsx_1.default();
    const [isDropDown, setIsDropDown] = react_1.useState(false);
    const dropdownRef = react_1.useRef(null);
    const [selectOptions, setSelectOptions] = react_1.useState(props.options || []);
    const [selectedValues, setSelectedValues] = react_1.useState(props.value || []);
    react_1.useEffect(() => {
        setSelectedValues(props.value || []);
        setSelectOptions(props.options || []);
    }, [props.value, props.options]);
    const handleValueChange = (option) => {
        const updatedValues = selectedValues.includes(option)
            ? selectedValues.filter((selected) => selected !== option)
            : [...selectedValues, option];
        setSelectedValues(updatedValues);
        props.setSelectOption(updatedValues);
    };
    const handleRemove = (option) => {
        const updatedValues = selectedValues.filter((selected) => selected !== option);
        setSelectedValues(updatedValues);
        props.setSelectOption(updatedValues);
    };
    const visibleChips = selectedValues.slice(0, 2);
    const hiddenCount = selectedValues.length - visibleChips.length;
    return (react_1.default.createElement(core_1.Grid, { ref: dropdownRef, container: true, style: {
            position: "relative",
            pointerEvents: props.disabled ? "none" : "auto",
            opacity: props.disabled ? 0.6 : 1,
        } },
        react_1.default.createElement(core_1.Grid, { container: true, className: classes.inputBaseStyle, style: { borderColor: "#aaaaaa" }, onClick: () => setIsDropDown((prev) => !prev) },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 10, className: classes.inputContainer }, selectedValues.length === 0 ? (react_1.default.createElement(core_1.InputBase, { placeholder: props.emptyTag || "Select options", style: {
                    border: "none",
                    cursor: "pointer",
                    marginLeft: "10px",
                    fontSize: "13px",
                }, value: "", fullWidth: true, readOnly: true })) : (react_1.default.createElement(react_1.default.Fragment, null,
                visibleChips.map((value, index) => (react_1.default.createElement(core_1.Chip, { key: `${value}-${index}`, label: value, className: classes.chip, onDelete: () => handleRemove(value), style: { margin: "2px" } }))),
                hiddenCount > 0 && (react_1.default.createElement(core_1.Chip, { label: `+${hiddenCount}`, className: classes.chip, style: { margin: "2px", cursor: "pointer" }, onClick: (e) => {
                        e.stopPropagation();
                        setIsDropDown(true);
                    } }))))),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 2, className: classes.iconContainer, style: { zIndex: 1 } }, isDropDown ? react_1.default.createElement(Icons_1.UpArrow, null) : react_1.default.createElement(Icons_1.DownArrowIcon, null))),
        isDropDown && (react_1.default.createElement("div", { className: classes.dropdown }, selectOptions.map((option, index) => (react_1.default.createElement(core_1.Grid, { container: true, alignItems: "center", className: classes.checkboxDropdownOption, key: `${option}-${index}` },
            react_1.default.createElement(core_1.FormGroup, { style: { margin: "0px" } },
                react_1.default.createElement(core_1.FormControlLabel, { className: classes.typo, control: react_1.default.createElement(core_1.Checkbox, { checked: selectedValues.includes(option), onChange: () => handleValueChange(option), color: "primary" }), label: option })))))))));
}
exports.CheckBoxDropDown = CheckBoxDropDown;
//# sourceMappingURL=CheckBoxDropDown.js.map